// import React, { createContext, useContext, useState, useEffect } from 'react';
// import { getDecryptedAccessToken, getDecryptedUserType } from '../LoginUserDetails.js/LoginUserSavedDetails';
// import ApiServices from '../ApiServices/ApiServices';

// const ApiContext = createContext();

// export const ApiProvider = ({ children }) => {
//   const [patients, setPatients] = useState([]);
//   const [appointments, setAppointments] = useState([]);
//   const [doctors, setDoctore] = useState([]);
//   const [services, setServices] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const accessToken = getDecryptedAccessToken();
//   const LoginUserType = getDecryptedUserType();

//   const fetchData = async (url, setter) => {
//     try {
//       const response = await ApiServices.get(url, {
//         Authorization: `Bearer ${accessToken}`,
//       });
//       // console.log(`Response from ${url}:`, response.data);
//       setter(response.data);
//     } catch (error) {
//       console.error(`Error fetching data from ${url}:`, error);
//     }
//   };

//   useEffect(() => {
//     if (accessToken) {
      
//       if (LoginUserType !== 'Patient') {
//         fetchData('/apis/default/api/patient', setPatients);
//         fetchData('/apis/default/api/appointmentBooked', setAppointments);
//         fetchData('/apis/default/api/practitioner', setDoctore);
//       }

//       let endpoint = '/apis/default/api/masterServices';
//       if (LoginUserType === 'Patient') {
//         endpoint = '/apis/default/portal/masterServices';
//       }
//       fetchData(endpoint, setServices);
//     }
//     setLoading(false);
//   }, [accessToken, LoginUserType]);

//   return (
//     <ApiContext.Provider value={{ patients, appointments, services, doctors,loading, fetchData }}>
//       {children}
//     </ApiContext.Provider>
//   );
// };

// export const useApiContext = () => useContext(ApiContext);



import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getDecryptedAccessToken, getDecryptedUserType } from '../LoginUserDetails.js/LoginUserSavedDetails';
import ApiServices from '../ApiServices/ApiServices';

const ApiContext = createContext();

export const ApiProvider = ({ children }) => {
  const [patients, setPatients] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [services, setServices] = useState([]);
  const [exercises, setExercises] = useState([]);
  const [loading, setLoading] = useState(true);

  const accessToken = getDecryptedAccessToken();
  const LoginUserType = getDecryptedUserType();

  // **Reusable API fetch function**
  const fetchData = useCallback(async (url, setter) => {
    try {
      const response = await ApiServices.get(url, {
        Authorization: `Bearer ${accessToken}`,
      });
      setter(response.data);
    } catch (error) {
      console.error(`Error fetching data from ${url}:`, error);
    }
  }, [accessToken]);

  // **Fetch data when accessToken is available**
  useEffect(() => {
    if (!accessToken) return; // Wait for accessToken before fetching

    setLoading(true);

    const fetchAllData = async () => {
      try {
        if (LoginUserType !== 'Patient') {
          await Promise.all([
            fetchData('/apis/default/api/patient', setPatients),
            fetchData('/apis/default/api/appointmentBooked', setAppointments),
            fetchData('/apis/default/api/practitioner', setDoctors),
            fetchData('/apis/default/api/exercises', setExercises),
          ]);
        }

        const endpoint =
          LoginUserType === 'Patient'
            ? '/apis/default/portal/masterServices'
            : '/apis/default/api/masterServices';

        await fetchData(endpoint, setServices);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [accessToken, LoginUserType, fetchData]);

  return (
    <ApiContext.Provider value={{ patients, appointments, services, doctors,exercises, loading, fetchData }}>
      {children}
    </ApiContext.Provider>
  );
};

export const useApiContext = () => useContext(ApiContext);
